import React, { Component } from 'react';
import 'HELPDESK/Components/CoordinatorDetails/coordinatordetails.css';
import 'HELPDESK/Components/ProductDocumentation/productdocumentation.css';
import config from 'config';
import HelpdeskApiCall from 'HelpdeskApiCall';
import SuccessModal from 'HELPDESK/CommonResources/SuccessModal/SuccessModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ButtonLoader from 'HELPDESK/CommonResources/ButtonLoader/ButtonLoader';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import ReactHtmlParser from 'react-html-parser';
import Pagination from 'react-js-pagination';
import DeleteTextModal from 'HELPDESK/CommonResources/DeleteTextModal/DeleteTextModal';
import ReactToPrint from 'react-to-print';
import ModulePresentation from 'HELPDESK/Components/CoordinatorDetails/ModulePresentation';
import { Base64, fromBase64, toBase64 } from 'js-base64';

class ProductDocumentation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            coordinatorFetching: false,
            coordinatorList: {},
            moduleListWithDemoPoint:{},
            filterName: '',
            pageIndex: 1,
            limit: 10,
            offset: 0,
            coordinatorCount: 0,

            // VARIABLES TO GET EMPLOYEE LIST
            employeeFetching: false,
            employeeList: {},
            searchTerm: '',

            // VARIABLES TO GET DEPARTMENT LIST
            departmentList: {},

            // VARIABLES TO GET MODULE LIST
            moduleFetching: false,
            moduleList: {},
            
            // VARIABLES TO ADD COORDINATOR
            addCoordinator: false,
            addingCoordinator: false,
            selectModule: true,
            tempSelectedModule: '',
            tempSelectedModuleName: '',
            selectedModule: '',
            selectedModuleName: '',
            moduleWarning: '',
            selectEmployee: false,
            tempSelectedEmployeeId: '',
            tempSelectedEmployeeName: '',
            selectedEmployeeId: '',
            selectedEmployeeName: '',
            selectedDepartmentIds: [],
            employeeWarning: '',

            // VARIABLES TO DELETE COORDINATOR 
            deleteCoordinator: false,
            moduleUniqueId: '',
            coordinatorId: '',

            //VARIABLES FOR ACCESS
            accessResponse :'',
            onboardingAccess:false,                        
            adminName:'',

            // VARIABLES FOR DEMO POINT ATTACHMENTS
            viewAttachment: false,
            attachmentArray: [],
            selectedAttachmentFile: '',
            currentAttachmentIndex: 0,

            // VARIABLES TO VIEW DETAILED PRESENTATION
            detailedPresentation: false,
            detailedModuleList: {},
            currentModuleId: '',
            currentModuleName: '',

            // VARIABLES TO SHIFT SUB MODULE
            currentSubModuleObject: {},
            subModuleIds: [],
            currentSubModuleId: '',
            currentSubModuleIndex: 0,
            subModuleNameObject: {},

            // VARIABLES TO SHIFT POINT
            currentPointIds: [],
            currentPointId: '',
            currentPointIndex: 0,
            currentPointNameObject: {},

            // VARIABLES TO SHIFT ATTACHMENT
            currentAttachmentArray: [],
            currentAttachmentPath: '',
            currentAttachmentIdx: 0,

            // VARIABLES TO COLLAPSE TABLE CONTENT
            collapseStatus: 'expanded'
        };
    }

    componentDidMount() {
        // // API CALL METHOD TO GET MODULE DETAILS
        this.apiCallToGetModuleList();
    }
    
    componentDidUpdate() {
        
        if(this.state.detailedPresentation) {
            document.onkeydown = (e) => {
                
                if(e.keyCode == 37) {
                    // METHOD TO GET PREVIOUS SUBMODULE POINT DETAILS
                    this.getPreviousPresentation(); 
                }else if(e.keyCode == 39) {
                    // METHOD TO GET NEXT SUBMODULE POINT DETAILS
                    this.getNextPresentation(); 
                }
            }
        }
    }

    // API CALL METHOD TO GET MODULE LIST
    apiCallToGetModuleList = async () => {
        this.setState({
            moduleFetching: true
        });

        let requestData = {
            "iid": config.institute_id,
        };

        let jsonResponse = await HelpdeskApiCall.makeApiCall(
            'GetHelpDeskModuleList',
            requestData,
            '/api/helpDesk/employee/moduleInformation.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetModuleList()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                this.setState({
                    moduleFetching: false,
                    moduleList: apiResult
                });
            } else {
                this.setState({
                    moduleFetching: false,
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting module list. Please try again later.'
                });
            }
        }
    }

    // METHOD TO RETURN VIEW DETAILED PRESENTATION
    returnViewDetailedPresentation = () => {
        return(
            <div className={this.state.detailedPresentation ? "modal fade show" : "modal fade"} id="modalContainer" >
                
                <div className="modal-dialog viewDetailedPresentation-dialog">
                    <div className="modal-content viewDetailedPresentation-content">
                        <div className="modal-body viewDetailedPresentation-body">
                            <div className="detailedPresentationContainer">
                                {
                                    this.state.detailedPresentation && 
                                        <ModulePresentation 
                                            moduleId = {this.state.tempSelectedModule}
                                            source = {"helpDesk"}
                                            closeDetailedPresentation = {this.closeDetailedPresentation}
                                        />
                                }
                                
                                
                                {/* <iframe src={config.RootUrl+"/modules/helpdesk/#/"+toBase64(this.state.tempSelectedModule)} height='100%' width='100%' ></iframe> */}
                                {/* <iframe src={"http://localhost:3000/#/"+toBase64(this.state.tempSelectedModule)} height='100%' width='100%' ></iframe> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // METHOD TO CLOSE DETAILED PRESENTATION
    closeDetailedPresentation = () => {
        let currentSubModuleObject = this.state.currentSubModuleObject;

        let currentSubModuleIndex = 0;
        let currentSubModuleId = this.state.subModuleIds[currentSubModuleIndex];

        if(currentSubModuleObject[currentSubModuleId] != undefined) {
            if(Object.keys(currentSubModuleObject[currentSubModuleId].demo_point).length > 0) {
                let demoPoints = Object.keys(currentSubModuleObject[currentSubModuleId].demo_point);

                let currentPointIndex = 0;
                let currentPointId = demoPoints[currentPointIndex];

                let attachments = currentSubModuleObject[currentSubModuleId].demo_point[currentPointId].attachments;
                let attachmentArray = attachments == null ? [] : attachments.split(',');
                let attachmentPath = currentSubModuleObject[currentSubModuleId].demo_point[currentPointId].attachmentPath;

                this.setState({
                    currentSubModuleIndex: 0,
                    currentSubModuleId: currentSubModuleId,
                    currentPointIndex: 0,
                    currentPointId: currentPointId,
                    currentAttachmentArray: attachmentArray,
                    currentAttachmentPath: attachmentPath,
                    currentAttachmentIdx: 0
                });
            }else {
                this.setState({
                    currentSubModuleIndex: currentSubModuleIndex,
                    currentSubModuleId: currentSubModuleId
                }, () => {
                    // METHOD TO SET NEXT SUB MODULE DETAILS
                    this.setNextSubModuleDemoPointDetails();
                });
            }
        }

        this.setState({
            detailedPresentation: false
        });
    }

    // METHOD TO COPY PRESENTATION URL
    copyPresentationUrl = (selectedModuleId) => {
        let presentationUrl = '';

        presentationUrl = config.RootUrl+'/modules/helpdesk/#/'+toBase64(selectedModuleId);

        navigator.clipboard.writeText(presentationUrl);
    }

    // API CALL METHOD TO GET MODULE LIST
    apiCallToGetModuleListWithDemoPoint = async (selectedModuleId) => {
        this.setState({
            moduleFetching: true
        });

        let requestData = {
            "iid": config.institute_id,
            "filter_module": selectedModuleId,
            // "search": this.state.searchTerm
        };

        let jsonResponse = await HelpdeskApiCall.makeApiCall(
            'GetHelpDeskModuleLSubmoduleListWithPoints',
            requestData,
            '/api/helpDesk/employee/moduleInformation.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetModuleListWithDemoPoint()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                
                this.setState({
                    moduleFetching: false,
                    moduleListWithDemoPoint: apiResult,
                    detailedModuleList: apiResult
                },
                    () => this.setModuleDemoPointData(selectedModuleId)
                );
            } else {
                this.setState({
                    moduleFetching: false,
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting module list. Please try again later.'
                });
            }
        }
    }

    // METHOD TO SET MODULE DEMO POINT DETAILS
    setModuleDemoPointData = (moduleId) => {
        let attachmentArray = this.state.attachmentArray;
        let moduleListWithDemoPoint = this.state.moduleListWithDemoPoint;
        let subModuleNameObject = this.state.subModuleNameObject;
        let currentPointNameObject = this.state.currentPointNameObject;

        subModuleNameObject = {};
        currentPointNameObject = {};

        attachmentArray = [];

        if(moduleListWithDemoPoint[moduleId] != undefined)
        {
            let subModules = moduleListWithDemoPoint[moduleId]['subModules'];

            if(Object.keys(subModules).length > 0)
            {
                Object.values(subModules).map(subModule => {
                    let demoPoint = subModule.demo_point;

                    if(Object.keys(demoPoint).length > 0)
                    {
                        Object.keys(demoPoint).map(pointId => {
                            let point = demoPoint[pointId];
                            let attachmentPath = point.attachmentPath != undefined ? point.attachmentPath : "";
                            let attachment = point.attachments != "" && point.attachments != null ? point.attachments.split(",") : [];

                            if(attachment.length > 0)
                            {
                                attachment.map(file => {
                                    let fileName = attachmentPath+"/"+file;

                                    attachmentArray.push(fileName);
                                })
                            } 
                        });
                    }
                });
            }
        }

        if(moduleListWithDemoPoint[moduleId] != undefined) {
            let subModules = moduleListWithDemoPoint[moduleId]['subModules'];

            if(Object.keys(subModules).length > 0) {
                Object.keys(subModules).map((subModuleId, subModuleIndex) => {
                    if(subModuleIndex == 0) {
                        if(Object.keys(subModules[subModuleId].demo_point).length > 0) {
                            Object.keys(subModules[subModuleId].demo_point).map((pointId, pointIndex) => {
                                if(pointIndex == 0) {
                                    let attachments = subModules[subModuleId].demo_point[pointId].attachments;
                                    let attachmentArray = attachments == null ? [] : attachments.split(',');

                                    this.setState({
                                        currentAttachmentArray: attachmentArray,
                                        currentAttachmentPath: subModules[subModuleId].demo_point[pointId].attachmentPath,
                                        currentAttachmentIdx: 0,
                                        currentPointId: pointId,
                                        currentPointIds: Object.keys(subModules[subModuleId].demo_point),
                                        currentPointIndex: pointIndex
                                    });
                                }

                                currentPointNameObject[pointId] = subModules[subModuleId].demo_point[pointId].point;
                            });

                            this.setState({
                                currentSubModuleId: subModuleId,
                                currentSubModuleIndex: subModuleIndex
                            });
                        }else {
                            this.setState({
                                currentSubModuleId: subModuleId,
                                currentSubModuleIndex: subModuleIndex
                            }, () => {
                                // METHOD TO GET NEXT SUBMODULE DETAILS
                                this.setNextSubModuleDemoPointDetails();
                            });
                        }
                    }

                    subModuleNameObject[subModuleId] = subModules[subModuleId].module_name;
                });
            }

            this.setState({
                subModuleIds: Object.keys(subModules),
                currentSubModuleObject: subModules
            });
        }else {
            this.setState({
                currentAttachmentArray: [],
                currentAttachmentPath: ''
            });
        }

        this.setState({
            attachmentArray,
            subModuleNameObject,
            currentPointNameObject
        });
    }

    // METHOD TO SET NEXT SUBMODULE DEMO POINT DETAILS
    setNextSubModuleDemoPointDetails = () => {
        let currentSubModuleIndex = this.state.currentSubModuleIndex + 1;
        let currentSubModuleId = this.state.subModuleIds[currentSubModuleIndex];

        if(this.state.currentSubModuleObject[currentSubModuleId] != undefined) {
            let demoPoints = Object.keys(this.state.currentSubModuleObject[currentSubModuleId].demo_point);

            if(demoPoints.length > 0) {
                let currentPointIndex = 0;
                let currentPointId = demoPoints[currentPointIndex];

                let point = this.state.currentSubModuleObject[currentSubModuleId].demo_point[currentPointId];
            
                let attachments = point.attachments;
                let attachmentArray = attachments == null ? [] : attachments.split(',');
                let attachmentPath = point.attachmentPath;

                this.setState({
                    currentAttachmentArray: attachmentArray,
                    currentSubModuleIndex: currentSubModuleIndex,
                    currentSubModuleId: currentSubModuleId,
                    currentAttachmentPath: attachmentPath,
                    currentAttachmentIdx: 0,
                    currentPointIds: demoPoints,
                    currentPointIndex: currentPointIndex,
                    currentPointId: currentPointId
                });
            }else {
                this.setState({
                    currentSubModuleIndex: currentSubModuleIndex,
                    currentSubModuleId: currentSubModuleId
                }, () => {
                    // METHOD TO GET NEXT SUB MODULE DETAILS
                    this.setNextSubModuleDemoPointDetails();
                });
            }
        }
    }

    // METHOD TO RETURN SELECT MODULE MODAL
    returnSelectModule = () => {
        return(
            <div className={this.state.selectModule ? "modal fade show" : "modal fade"} id="modalContainer" >
                <div className="modal-dialog modal-dialog-centered viewProductDocumentation-dialog " >
                    <div className="modal-content viewProductDocumentation-content">
                        <div className="modal-header">
                            <h3 style={{ textTransform: "capitalize", fontSize: 20 }}>Select Module</h3>
                        </div>
                        <div className="modal-body viewModuleWiseDemoPoint-body">
                            <div className="moduleWisePointContainer">
                                {
                                    this.state.moduleFetching ?
                                        <ButtonLoader />
                                    :
                                    <>  
                                        <div className="col-md-3" style={{padding: "0 15px 0 0"}}>
                                            <div className=" ModuleWisePointListContainer ">
                                                {
                                                    Object.values(this.state.moduleList).map(module => {
                                                        return(
                                                            <div  onClick={(e) => this.selectModule(e, module)} className= {this.state.tempSelectedModule == module.moduleId ? "moduleSelected module" : "module"}>
                                                                <input
                                                                    type='radio'
                                                                    name="module"
                                                                    style={{ marginRight: 5 }}
                                                                    checked={this.state.tempSelectedModule == module.moduleId}
                                                                />
                                                                <span>{module.module_name}</span>
                                                            </div>
                                                        );
                                                    })
                                                }
                                            </div>
                                        </div>
                                        <div className="subModuleDemoPointContainer col-md-9">  
                                            {
                                                this.state.moduleListWithDemoPoint[this.state.tempSelectedModule] &&
                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                        <div className = "moduleNameContainer">
                                                            {this.state.moduleListWithDemoPoint[this.state.tempSelectedModule]["module_name"] + " | SubModule and its features"}
                                                        </div>
                                                        <p className="detailedPresentation" onClick={() => this.setState({ detailedPresentation: true })}>
                                                            View Detailed Presentation
                                                            <FontAwesomeIcon icon={['fas', 'external-link-square-alt']} size="lg" style={{ marginLeft: 5 }} />
                                                        </p>
                                                        <FontAwesomeIcon icon={['fas', 'copy']} title="Copy presentation URL" size="md" style={{ marginLeft: 10, color: '#818181', cursor: 'pointer' }} onClick={ () => this.copyPresentationUrl(this.state.tempSelectedModule) } />
                                                    </div>
                                            }
                                            <div className="col-md-12">
                                            {
                                                this.state.moduleListWithDemoPoint[this.state.tempSelectedModule] != undefined &&
                                                    Object.values( this.state.moduleListWithDemoPoint[this.state.tempSelectedModule]["subModules"]).length > 0 ? 
                                                    this.state.moduleListWithDemoPoint[this.state.tempSelectedModule]["subModuleSequenceIdArray"].map((subModuleId,SubModuleIndex) =>{
                                                        let subModule = this.state.moduleListWithDemoPoint[this.state.tempSelectedModule]["subModules"][subModuleId]
                                                            return(
                                                                <div style={{ marginBottom: 10 }}>
                                                                    <div style={{fontWeight:'bold'}}>{SubModuleIndex+1}. <span style={{textDecoration:"underLine"}}>{subModule.module_name}</span></div>
                                                                    
                                                                        <div className= "col-md-12">
                                                                        {
                                                                            subModule["demoPointSequence"].map((demoPointId,demoPointIndex) =>{
                                                                                let demoPoint = subModule['demo_point'][demoPointId]
                                                                                return(

                                                                                    <div>{ReactHtmlParser(demoPoint.point)}</div>
                                                                                )
                                                                            })
                                                                        }
                                                                        </div>
                                                                </div>
                                                            )
                                                        })
                                                :
                                                    (this.state.tempSelectedModule != undefined && this.state.tempSelectedModule.length < 1) ?
                                                        <p style={{ color: '#818181', fontSize: 14 }}>Please select module to get sub module details.</p>
                                                    :
                                                        <p style={{ color: '#818181', fontSize: 14 }}>Sub module is not added for {this.state.tempSelectedModuleName}.</p>
                                            }
                                            </div>                                    
                                        </div>
                                    </>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // METHOD TO SELECT MODULE DETAILS
    selectModule = (e, module) => {
        
        this.apiCallToGetModuleListWithDemoPoint(module.moduleId);

        this.setState({
            tempSelectedModule: module.moduleId,
            tempSelectedModuleName: module.module_name,
            currentModuleId: module.moduleId,
            currentModuleName: module.module_name
        });
    }

    // METHOD TO CLOSE SELECT MODULE MODAL
    closeSelectModule = () => {
        this.setState({
            selectModule: false,
            tempSelectedModule: this.state.selectedModule,
            tempSelectedModuleName: this.state.selectedModuleName
        });
    }
    
    // METHOD TO CLOSE SUCCESS MODAL
    closeSuccessModal = () => {
        this.setState({
            successModal: false,
        });
    }

    render() {
        return (
            <>
                {
                    this.returnSelectModule()
                }
                {
                    this.returnViewDetailedPresentation()
                }
            </>
        );
    }
}

export default ProductDocumentation;